import { defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: dialogAnatomy.keys(),
  variants: {
    size: {
      '2xl': {},
    },
  },
});
